import { render, staticRenderFns } from "./Integrations.vue?vue&type=template&id=235bd9de&scoped=true"
import script from "./Integrations.vue?vue&type=script&lang=js"
export * from "./Integrations.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "235bd9de",
  null
  
)

export default component.exports